import { getCookie, setCookie, unsetCookie } from '@/lib/util';
const expires = new Date();
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
expires.setFullYear(expires.getFullYear() + 5);
// expires.setDate(expires.getDate() + 3);
export function setItem(key: string, value: string) {
  return setCookie(key, value, expires);
}
export function getItem(key: string) {
  return getCookie(key);
}

export function removeItem(key: string) {
  return unsetCookie(key);
}
// export function makeTracker(defaultPayload: any) {
//   !defaultPayload && (defaultPayload = {});
//   return function(event: string, payload: any) {
//     !payload && (payload = {});
//     Object.assign(payload, defaultPayload);
//     trackerLoaded.then(tracker => {
//       tracker.track(event, payload);
//     });
//   };
// }
